/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Subscription_ErrorInputs */

const en_plan_subscription_error = /** @type {(inputs: Plan_Subscription_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error updating subscription`)
};

const es_plan_subscription_error = /** @type {(inputs: Plan_Subscription_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar la suscripción`)
};

/**
* | output |
* | --- |
* | "Error updating subscription" |
*
* @param {Plan_Subscription_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_subscription_error = /** @type {((inputs?: Plan_Subscription_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Subscription_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_subscription_error(inputs)
	return en_plan_subscription_error(inputs)
});